import React from "react";

const MAP = {
  NEW: { bg: "#DBEAFE", text: "#1E40AF", label: "NEW" },
  SCHEDULED: { bg: "#E0E7FF", text: "#181854", label: "SCHEDULED" },
  EN_ROUTE: { bg: "#FEF3C7", text: "#92400E", label: "EN ROUTE" },
  ON_SITE: { bg: "#FED7AA", text: "#9A3412", label: "ON SITE" },
  COMPLETE: { bg: "#DCFCE7", text: "#166534", label: "COMPLETE" },
  INVOICED: { bg: "#E4E6EF", text: "#181854", label: "INVOICED" },
  CLOSED: { bg: "#E4E6EF", text: "#6A6E85", label: "CLOSED" },
};

export default function StatusPill({ status, size = "sm", className = "" }) {
  const cfg = MAP[status] || { bg: "#E4E6EF", text: "#6A6E85", label: status };
  const padding = size === "lg" ? "px-4 py-1.5 text-sm" : "px-2.5 py-1 text-[11px]";
  return (
    <span
      data-testid={`status-pill-${status}`}
      className={`inline-flex items-center rounded-full font-bold uppercase tracking-wider ${padding} ${className}`}
      style={{ backgroundColor: cfg.bg, color: cfg.text }}
    >
      {cfg.label}
    </span>
  );
}
